export default "__VITE_ASSET__BNhP2p_7__"